<template>
	<Modal
		:open="isOpen"
		:has-footer="false"
		:blocking="blocking"
		class="list-context-menu"
		:closeable="false"
		:force-backdrop-close="true"
		@close="$emit('close')"
	>
		<template #header>
			<slot name="header">
				<div class="title">
					{{ title }}
				</div>
			</slot>
		</template>

		<template #body>
			<slot name="list-body">
				<div
					v-for="(item, idx) in menuItems"
					:key="idx"
					class="menu-item"
					:class="{selected: isSelected(item.id)}"
					@click="handleItemClick(item)"
				>
					<slot
						name="menu-item"
						:item="item"
					>
						<div class="menu-item--check">
							<Icon
								v-if="isSelected(item.id)"
								icon-name="check"
								size="lg"
							/>
						</div>
						<div
							v-if="item.label"
							class="menu-item--label"
						>
							{{ item.label }}
						</div>
					</slot>
				</div>
			</slot>
		</template>
	</Modal>
</template>

<script>
import Modal from '../modal/Modal';
import ContextMenuMobileMixin from './ContextMenuMobileMixin';

export default {
	name:       'ListContextMenuMobile',
	components: { Modal },
	mixins:     [ContextMenuMobileMixin],
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts.scss';

.title {
	@include text-md-2(true);
}

.list-body {
	width: 100%;
	border-collapse: collapse;
}

.menu-item {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	white-space: nowrap;
	padding: 16px 18px;

	&--check {
		color: var(--color-hype-yellow);
		min-width: 24px;
		margin-right: 18px;
	}

	&--label {
		flex-grow: 1;
	}
}

.list-context-menu::v-deep {
	.modal--header {
		border-bottom: none;
	}

	.modal--body {
		padding: 0 0 12px 0;
	}
}

</style>
